var React = require('react');

function RedwerksLogo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"style":{"fill":"#ff2e00","fillOpacity":"1","strokeWidth":"0.264583"},"id":"rect1102","width":"1.3864167","height":"7.5379791","x":"-0.69320834","y":"0.72113836","rx":"0.69320834","transform":"rotate(-45)","key":0}),React.createElement("rect",{"style":{"fill":"#000000","fillOpacity":"1","strokeWidth":"0.274309"},"id":"rect1649","width":"1.3864167","height":"7.5379791","x":"3.7969193","y":"-3.7689896","rx":"0.74511003","transform":"rotate(45)","key":1})]);
}

RedwerksLogo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 6.3499998 6.3499998","version":"1.1"};

module.exports = RedwerksLogo;

RedwerksLogo.default = RedwerksLogo;
